import React, { useState, useEffect } from 'react';
import { FiX, FiPlus } from 'react-icons/fi';
import { database } from '../../Firebase';
import { ref, onValue, push } from 'firebase/database';

const PersonSelectionModal = ({ isOpen, onClose, onSelect, onAddNew }) => {
  const [searchParams, setSearchParams] = useState({
    aadharNo: '',
    firstName: '',
    middleName: '',
    lastName: ''
  });

  const [personList, setPersonList] = useState([]);

  // Fetch Persons from Firebase
  useEffect(() => {
    const personRef = ref(database, 'Grampanchayat/Gramniddhi/Certificates and licenses/PersonList');
    
    const unsubscribe = onValue(personRef, (snapshot) => {
      const fetchedData = [];
      snapshot.forEach((childSnapshot) => {
        fetchedData.push({
          id: childSnapshot.key,
          ...childSnapshot.val()
        });
      });
      setPersonList(fetchedData);
    });

    return () => unsubscribe();
  }, []);

  if (!isOpen) return null;

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchParams(prev => ({ ...prev, [name]: value }));
  };

  const handleAddNewPerson = () => {
    if (onAddNew) {
        onAddNew();
        return;
    }

    // Legacy quick-add logic
    // Validate inputs
    if (!searchParams.firstName || !searchParams.lastName) {
        alert('कृपया किमान नाव आणि आडनाव भरा');
        return;
    }

    const fullName = `${searchParams.firstName} ${searchParams.middleName || ''} ${searchParams.lastName}`;
    const newPerson = {
        firstName: searchParams.firstName,
        middleName: searchParams.middleName || '',
        lastName: searchParams.lastName,
        aadharNo: searchParams.aadharNo || '',
        fullName: fullName.replace(/\s+/g, ' ').trim(), // Clean up extra spaces
        createdAt: new Date().toISOString()
    };

    const personRef = ref(database, 'Grampanchayat/Gramniddhi/Certificates and licenses/PersonList');
    push(personRef, newPerson)
        .then(() => {
            alert('नवीन व्यक्ती यशस्वीरित्या जोडली!');
             setSearchParams({
                aadharNo: '',
                firstName: '',
                middleName: '',
                lastName: ''
            });
        })
        .catch((error) => {
            alert('जोडताना त्रुटी आली: ' + error.message);
        });
  };

  // Filter list based on inputs
  const filteredList = personList.filter(person => {
      const sFirst = searchParams.firstName.toLowerCase();
      const sMiddle = searchParams.middleName.toLowerCase();
      const sLast = searchParams.lastName.toLowerCase();
      const sAadhar = searchParams.aadharNo;

      return (
          (!sFirst || person.firstName.toLowerCase().includes(sFirst)) &&
          (!sMiddle || person.middleName.toLowerCase().includes(sMiddle)) &&
          (!sLast || person.lastName.toLowerCase().includes(sLast)) &&
          (!sAadhar || person.aadharNo.includes(sAadhar))
      );
  });

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl overflow-hidden">
        
        {/* Header */}
        <div className="bg-[#267c77] text-white p-4 flex justify-between items-center">
          <h2 className="text-xl font-semibold">
            व्यक्तीची माहिती
          </h2>
          <button onClick={onClose} className="text-white hover:text-gray-200">
            <FiX size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
            {/* Input Fields */}
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6 items-end">
            <div>
                <label className="block text-gray-700 text-sm mb-1">आधार क्र.</label>
                <input
                    type="text"
                    name="aadharNo"
                    value={searchParams.aadharNo}
                    onChange={handleSearchChange}
                    placeholder="आधार नं."
                    className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-[#267c77]"
                />
            </div>
            <div>
                <label className="block text-gray-700 text-sm mb-1">नाव</label>
                <input
                    type="text"
                    name="firstName"
                    value={searchParams.firstName}
                    onChange={handleSearchChange}
                    placeholder="पहिले नाव"
                    className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-[#267c77]"
                />
            </div>
            <div>
                <label className="block text-gray-700 text-sm mb-1">वडिलांचे/पतीचे नाव</label>
                <input
                    type="text"
                    name="middleName"
                    value={searchParams.middleName}
                    onChange={handleSearchChange}
                    placeholder="वडिलांचे/पतीचे नाव"
                    className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-[#267c77]"
                />
            </div>
            <div>
                <label className="block text-gray-700 text-sm mb-1">आडनाव</label>
                <input
                    type="text"
                    name="lastName"
                    value={searchParams.lastName}
                    onChange={handleSearchChange}
                    placeholder="आडनाव"
                    className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-[#267c77]"
                />
            </div>
                <div>
                <label className="block text-gray-700 text-sm mb-1">क्रिया</label>
                <button 
                    onClick={handleAddNewPerson}
                    className="w-full p-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] transition shadow-md"
                >
                    नवीन नोंदणी
                </button>
            </div>
            </div>

            {/* Results Table */}
            <div className="overflow-x-auto border border-gray-200 rounded-lg max-h-96">
            <table className="w-full text-left border-collapse">
                <thead className="bg-[#267c77] text-white sticky top-0">
                <tr>
                    <th className="p-3 border-r border-white/30 w-16 text-center">अ.क्र.</th>
                    <th className="p-3 border-r border-white/30">नाव</th>
                    <th className="p-3 border-r border-white/30">वडील/पतीचे नाव</th>
                    <th className="p-3 border-r border-white/30">आडनाव</th>
                    <th className="p-3 border-r border-white/30">आधार नं.</th>
                    <th className="p-3 text-center w-24">क्रिया</th>
                </tr>
                </thead>
                <tbody>
                {filteredList.length === 0 ? (
                    <tr>
                        <td colSpan="6" className="p-8 text-center text-gray-500">
                            {personList.length === 0 ? 'कोणीही व्यक्ती आढळली नाही. नवीन नोंदणी करा.' : 'या नावाने कोहीही आढळले नाही.'}
                        </td>
                    </tr>
                ) : (
                    filteredList.map((person, idx) => (
                        <tr key={person.id} className="hover:bg-gray-50 border-b">
                            <td className="p-3 border-r text-center font-medium text-gray-600">{idx + 1}</td>
                            <td className="p-3 border-r">{person.firstName}</td>
                            <td className="p-3 border-r">{person.middleName}</td>
                            <td className="p-3 border-r">{person.lastName}</td>
                            <td className="p-3 border-r">{person.aadharNo}</td>
                            <td className="p-3 text-center">
                                <button
                                    onClick={() => {
                                        onSelect(person);
                                        onClose();
                                    }}
                                    className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-3 py-1 rounded text-sm transition-colors flex items-center justify-center gap-1 mx-auto shadow-sm"
                                >
                                    <FiPlus size={16} /> निवडा
                                </button>
                            </td>
                        </tr>
                    ))
                )}
                </tbody>
            </table>
            </div>
        </div>
      </div>
    </div>
  );
};

export default PersonSelectionModal;
